import { render, staticRenderFns } from "./LeftBarItem.vue?vue&type=template&id=1f859903&"
import script from "./LeftBarItem.vue?vue&type=script&lang=js&"
export * from "./LeftBarItem.vue?vue&type=script&lang=js&"
import style0 from "./LeftBarItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports